var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrvsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prvsArrow",
    clipPath: "url(#clip0_11118_452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3096 0.395502C15.5731 0.659006 15.7048 0.970997 15.7048 1.33147C15.7048 1.69124 15.5731 2.00288 15.3096 2.26638L7.58889 9.98707L15.3359 17.7341C15.5819 17.98 15.7048 18.2875 15.7048 18.6564C15.7048 19.0253 15.5731 19.3415 15.3096 19.605C15.0461 19.8685 14.7341 20.0002 14.3736 20.0002C14.0138 20.0002 13.7022 19.8685 13.4387 19.605L4.58494 10.7249C4.47954 10.6195 4.4047 10.5053 4.36043 10.3823C4.31687 10.2594 4.29508 10.1276 4.29508 9.98707C4.29508 9.84653 4.31687 9.71478 4.36043 9.59181C4.4047 9.46884 4.47954 9.35466 4.58494 9.24926L13.465 0.369152C13.711 0.123215 14.0138 0.000244141 14.3736 0.000244141C14.7341 0.000244141 15.0461 0.131998 15.3096 0.395502Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11118_452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrvsArrow);
export default __webpack_public_path__ + "static/media/prvsArrow.1e0f1bad1ee948e7f1f967f0effe5cd8.svg";
export { ForwardRef as ReactComponent };